import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Registro } from './pages/Registro';
import { Gracias } from './pages/Gracias';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/registro" element={<Registro data-id="element-3" />} data-id="element-2" />
        <Route path="/gracias" element={<Gracias data-id="element-5" />} data-id="element-4" />
        <Route path="*" element={<Navigate to="/registro" replace data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}